import { render, staticRenderFns } from "./WEditDialog.vue?vue&type=template&id=bdc16b38&scoped=true&"
import script from "./WEditDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./WEditDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc16b38",
  null
  
)

export default component.exports